import { PayloadAction } from '@reduxjs/toolkit';
import { TemplateState } from 'src/store/template/types';

const setTemplateForcedMinPageCountReducer = (state: TemplateState, action: PayloadAction<number | undefined>) => {
  state.forcedMinPageCount = action.payload;
};

export default setTemplateForcedMinPageCountReducer;
